module.exports = __webpack_public_path__ + "img/studio-1.bd90b5d1.jpg";